import React from "react";
import _ from "lodash";
import { Button } from "components";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { faFileArrowDown } from "@fortawesome/pro-regular-svg-icons";
import { startCase } from "lodash";

type Props = {
  onClick?: () => void;
  data: any[];
  fileName: string;
  fieldsToExclude?: string[];
  removeIdSuffix?: boolean;
};

export default function ExportButton({
  data,
  fileName,
  fieldsToExclude,
  removeIdSuffix,
}: Props) {
  const disabled = _.isEmpty(data);
  const fieldNames: string[] = disabled
    ? []
    : Object.getOwnPropertyNames(data[0]);

  const formatFieldHeader = (fieldName: string, removeIdSuffix?: boolean) => {
  let cleaned = fieldName;
  if (removeIdSuffix 
      && fieldName.toLowerCase() !== "accountid"
      && fieldName.toLowerCase() !== "vendorid"
      && fieldName.toLowerCase() !== "supplierid") 
      {        
        cleaned = cleaned.replace(/id$/i, "");
      }
      return startCase(cleaned);
  };
  const _exporter = React.createRef<ExcelExport>();
  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };
  return (
    <>
      <Button
        iconDefinition={faFileArrowDown}
        iconPosition="right"
        fillMode="flat"
        themeColor="secondary"
        onClick={excelExport}
        disabled={disabled}
      ></Button>
      <ExcelExport data={data} fileName={fileName} ref={_exporter}>
        {fieldNames?.map((field) => {
          if (fieldsToExclude?.find((name) => name === field) == null) {
            return (
              <ExcelExportColumn
                key={field}
                field={field}
                title={formatFieldHeader(field, removeIdSuffix)}
              />
            );
          }
        })}
      </ExcelExport>
    </>
  );
}
